module.exports = __webpack_public_path__ + "static/media/common-misconceptions-about-payment.bdea94e6.md";